import ClientsView from '../../pages/ClientsView';

// Nome simples (PT): Página de Clientes
export default function PaginaClientes(props) {
  return <ClientsView {...props} />;
}






